<div class="mb-4 w-full">
  <!-- Gradient bar with separators -->
  <div class="relative mb-1 h-2 w-full rounded-full" [ngStyle]="gradient ? { background: gradient } : {}">
    <!-- Vertical separators for main risk assessment -->
    <ng-container *ngIf="!minimal">
      <div class="absolute inset-y-0 left-[5%] w-px bg-black/30"></div>
      <div class="absolute inset-y-0 left-[15%] w-px bg-black/30"></div>
      <div class="absolute inset-y-0 left-[50%] w-px bg-black/30"></div>
      <div class="absolute inset-y-0 left-[85%] w-px bg-black/30"></div>
    </ng-container>

    <!-- Normal range vertical lines for biomarker scales -->
    <ng-container *ngIf="shouldShowNormalRangeLines">
      <div class="absolute inset-y-0 w-px bg-neutral-gray60" [style.left]="normalRangeLines!.minPosition + '%'"></div>
      <div class="absolute inset-y-0 w-px bg-neutral-gray60" [style.left]="normalRangeLines!.maxPosition + '%'"></div>
    </ng-container>

    <!-- Risk indicator dot with custom tooltip -->
    <div
      *ngIf="isValueNumber(clampedValue)"
      class="absolute top-1/2 z-10 h-4 w-4 cursor-pointer rounded-full bg-black shadow-md"
      [style.left]="position + '%'"
      style="transform: translate(-50%, -50%)"
      (mouseenter)="showCustomTooltip = showTooltip"
      (mouseleave)="showCustomTooltip = false"></div>

    <!-- Custom Tooltip -->
    <div
      *ngIf="showCustomTooltip && isValueNumber(clampedValue)"
      class="custom-tooltip pointer-events-none absolute rounded-md border border-neutral-gray60 bg-neutral-gray70 px-3 py-2 text-sm text-neutral-white shadow-lg"
      style="z-index: 10000"
      [style.left]="getTooltipPosition().left"
      [style.top]="getTooltipPosition().top"
      [style.transform]="getTooltipPosition().transform">
      <div class="text-center">
        <div class="text-xl font-medium">
          {{ tooltipText ? (tooltipText | translate) : '' }}
        </div>
        <div *ngIf="showRiskCategory" class="text-sm font-medium">{{ riskCategory | translate }}</div>
      </div>
    </div>
  </div>

  <!-- Percentage labels -->
  <div *ngIf="!minimal" class="relative mt-3 h-6 w-full text-xs text-neutral-gray60">
    <ng-container *ngFor="let label of visiblePercentageLabels">
      <div
        class="absolute"
        [style.left]="label.position + '%'"
        [style.transform]="
          label.position === 0 ? 'none' : label.position === 100 ? 'translateX(-100%)' : 'translateX(-50%)'
        ">
        {{ label.text | translate }}
      </div>
    </ng-container>
  </div>

  <!-- Category labels - separate row -->
  <div *ngIf="!minimal" class="relative mt-1 h-6 w-full text-xs text-neutral-gray60">
    <ng-container *ngFor="let label of visibleCategoryLabels">
      <div class="absolute" [style.left]="label.position + '%'" [style.transform]="'translateX(-50%)'">
        {{ label.text | translate }}
      </div>
    </ng-container>
  </div>

  <!-- Normal range labels for biomarker scales -->
  <div *ngIf="shouldShowNormalRangeLines" class="relative mt-2 h-6 w-full text-xs font-medium text-neutral-gray60">
    <div
      class="pointer-events-none absolute select-none whitespace-nowrap"
      [style.left]="normalRangeLines!.minPosition + '%'"
      [style.transform]="getTransformForPosition(normalRangeLines!.minPosition)"
      [style.z-index]="10">
      {{ normalRangeLines!.minLabel }}
    </div>
    <div
      class="pointer-events-none absolute select-none whitespace-nowrap"
      [style.left]="normalRangeLines!.maxPosition + '%'"
      [style.transform]="getTransformForPosition(normalRangeLines!.maxPosition)"
      [style.z-index]="10">
      {{ normalRangeLines!.maxLabel }}
    </div>
  </div>
</div>
